import { render, staticRenderFns } from "./CompStars.vue?vue&type=template&id=4cb4d1b8&scoped=true"
import script from "./CompStars.vue?vue&type=script&setup=true&lang=js"
export * from "./CompStars.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CompStars.vue?vue&type=style&index=0&id=4cb4d1b8&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb4d1b8",
  null
  
)

export default component.exports